module.exports = __webpack_public_path__ + "assets/img/desc_active.3ea82e6a.png";